import { t } from "i18next";
import { CommissionsSettingsLevel } from "../../../../modules/commissions/level/types";
import { formatCommissionsLevelName } from "../../../../modules/commissions/level/utils";
import { CommissionsSettingsRank } from "../../../../modules/commissions/ranks/types";
import { CommissionsSettingsStatus } from "../../../../modules/commissions/settings/enums";
import { CommissionsSettings } from "../../../../modules/commissions/settings/types";
import { BooleanHistoryItem, DateHistoryItem, EmptyHistoryItem, NettoPointsHistoryItem } from "./commonHistoryItems";

const CommissionsSettingsLevelHistoryItem = (value?: CommissionsSettingsLevel) =>
  value ? <span>{formatCommissionsLevelName(value)}</span> : <EmptyHistoryItem />;

const CommissionsSettingsRankHistoryItem = (value?: CommissionsSettingsRank) =>
  value ? <span>{value.name}</span> : <EmptyHistoryItem />;

const CommissionsSettingsStatusHistoryItem = (value?: CommissionsSettingsStatus) =>
  value ? <span>{t("commissions.settings.enums.commissionsSettingsStatus." + value)}</span> : <EmptyHistoryItem />;

export const CommissionsSettingsHistoryItemsMap = new Map<
  Partial<keyof CommissionsSettings>,
  (value: any) => React.JSX.Element
>([
  ["lastLevelChangeDate", DateHistoryItem],
  ["includeInPrimaryBulkPayment", BooleanHistoryItem],
  ["includeInSecondaryBulkPayment", BooleanHistoryItem],
  ["useAsHead", BooleanHistoryItem],
  ["hasPrimaryManagerialCommissions", BooleanHistoryItem],
  ["hasSecondaryManagerialCommissions", BooleanHistoryItem],
  ["allowPromotion", BooleanHistoryItem],
  ["initialPrimaryIndividualPoints", NettoPointsHistoryItem],
  ["initialPrimaryGroupPoints", NettoPointsHistoryItem],
  ["initialSecondaryIndividualPoints", NettoPointsHistoryItem],
  ["initialSecondaryGroupPoints", NettoPointsHistoryItem],
  ["initialBonusIndividualPoints", NettoPointsHistoryItem],
  ["initialBonusGroupPoints", NettoPointsHistoryItem],
  ["status", CommissionsSettingsStatusHistoryItem],
  ["unifyPointsCalculation", BooleanHistoryItem],
  ["level", CommissionsSettingsLevelHistoryItem],
  ["rank", CommissionsSettingsRankHistoryItem],
]);
